import {useEffect} from "react";
import { useSelector,useDispatch } from "react-redux"
import { verifyPodcastRequest } from "features/VerifyPodcast/verifyPodcastSlice";
 

const useVerifyPodcastList = (start,limit) => {
   const dispatch = useDispatch();

   useEffect(()=>{
     dispatch(verifyPodcastRequest([start,limit]));
   },[start,limit,dispatch]);

   return useSelector((state)=>{
     if(state.verifyPodcast.verifyPodcastList) return state.verifyPodcast.verifyPodcastList;
     return [];
   })
}

export default useVerifyPodcastList;
